module.exports = __webpack_public_path__ + "static/grid_view.e184f92c.svg";